import React from 'react';

function BarFacebookIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      {...props}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0H40V40H0z"
                transform="translate(-1460 -562) translate(1460 562)"
              />
            </g>
            <g fill="#3DB2FF" fillRule="nonzero">
              <path
                d="M.435 14.38h2.96v12.185c0 .24.195.435.436.435h5.018c.24 0 .435-.195.435-.435V14.438h3.403c.22 0 .407-.166.432-.386l.517-4.486c.014-.123-.025-.247-.108-.34-.082-.092-.2-.145-.325-.145H9.284V6.269c0-.848.457-1.277 1.357-1.277h2.562c.241 0 .436-.195.436-.436V.44c0-.24-.195-.436-.436-.436h-3.53C9.646.002 9.591 0 9.51 0c-.612 0-2.742.12-4.425 1.668-1.864 1.715-1.604 3.769-1.543 4.125V9.08H.435c-.24 0-.435.195-.435.435v4.429c0 .24.195.435.435.435z"
                transform="translate(-1460 -562) translate(1460 562) translate(13 6.333)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BarFacebookIcon;
